// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"37875742","518":"471a140c","657":"becc7d6a"}[chunkId] + ".chunk.js";
};